import { Redirect, Route, Switch } from "react-router-dom/cjs/react-router-dom.min";
import HaccpPathConstants from "../constants/PathConstants";
import { Suspense, lazy } from "react";
import HaccpApp from "../components/templates/HaccpApp";
import HaccpLayout from "../components/templates/HaccpLayout";
import Fallback from "../components/organisms/Fallback";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

/** ホーム コンポーネント */
const Home = lazy(() => import("../components/pages/Home"));
/** 温度測定 測定対象登録 コンポーネント */
const TempMeasurementRegistration = lazy(() => import("../components/pages/registration/TempMeasurementRegistration"));
/** 加熱調理温度測定 測定対象登録 コンポーネント */
const CookingTempMeasurementRegistration = lazy(() => import("../components/pages/registration/CookingTempMeasurementRegistration"));
/** 加熱冷却温度測定 測定対象登録 コンポーネント */
// const HeatingAndCoolingTempMeasurementRegistration = lazy(() => import("../components/pages/registration/HeatingAndCoolingTempMeasurementRegistration"));
/** 温度測定 記録 コンポーネント */
const TempMeasurementRecord = lazy(() => import("../components/pages/record/TempMeasurementRecord"));
/** 受入温度測定 記録 コンポーネント */
const ReceivingTempMeasurementRecord = lazy(() => import("../components/pages/record/ReceivingTempMeasurementRecord"));
/** 加熱調理温度測定 記録 コンポーネント */
const CookingTempMeasurementRecord = lazy(() => import("../components/pages/record/CookingTempMeasurementRecord"));
/** 加熱冷却温度測定 記録 コンポーネント */
// const HeatingAndCoolingTempMeasurementRecord = lazy(() => import("../components/pages/record/HeatingAndCoolingTempMeasurementRecord.js"));
/** 庫温度測定 記録 コンポーネント */
const CabinetTempMeasurementRecord = lazy(() => import("../components/pages/record/CabinetTempMeasurementRecord"));


/** 食品メーカー向けサービス Router コンポーネント */
const HaccpContent = () => {
    return (
        <HaccpApp>
            <HaccpLayout>
                <Suspense fallback={<Fallback />}>
                    <Switch>
                        <Route
                            exact
                            path={HaccpPathConstants.Home}
                            component={Home} />
                        <Route 
                            exact
                            path={HaccpPathConstants.TempMeasurementRegistration} 
                            component={TempMeasurementRegistration} />
                        <Route 
                            exact
                            path={HaccpPathConstants.CookingTempMeasurementRegistration}
                            component={CookingTempMeasurementRegistration} />
                        {/* <Route
                            exact
                            path={HaccpPathConstants.HeatingAndCoolingTempMeasurementRegistration}
                            component={HeatingAndCoolingTempMeasurementRegistration} /> */}
                        <Route 
                            exact 
                            path={HaccpPathConstants.TempMeasurementRecord}
                            component={TempMeasurementRecord} />
                        <Route 
                            exact
                            path={HaccpPathConstants.ReceivingTempMeasurementRecord}
                            component={ReceivingTempMeasurementRecord} />
                        <Route 
                            exact 
                            path={HaccpPathConstants.CookingTempMeasurementRecord}
                            component={CookingTempMeasurementRecord} />
                        {/* <Route 
                            exact
                            path={HaccpPathConstants.HeatingAndCoolingTempMeasurementRecord}
                            component={HeatingAndCoolingTempMeasurementRecord} /> */}
                        <Route
                            exact
                            path={HaccpPathConstants.CabinetTempMeasurementRecord}
                            component={CabinetTempMeasurementRecord} />
                        <Redirect to={HaccpPathConstants.Home} />
                    </Switch>
                </Suspense>
            </HaccpLayout>
        </HaccpApp>
    );
};

export default HaccpContent;
